import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useGetAllBookings } from "../../../../api/fleet-management/bookings/booking.hooks";
import BookingsHeader from "./_components/BookingsHeader";
import BookingsTable from "./_components/BookingsTable";
import { filterBookings, normalizeBookings } from "./utils/booking.utils";
import { useHistory } from "react-router-dom";

const Bookings = () => {
  const history = useHistory();
  const { data, isLoading, isError, error } = useGetAllBookings();

  const [searchTerm, setSearchTerm] = useState("");

  const bookings = normalizeBookings(data);

  const filteredBookings = useMemo(() => {
    return filterBookings(bookings, searchTerm);
  }, [bookings, searchTerm]);

  const handleViewDetails = (booking) => {
    if (!booking?._id) return;
    history.push(`/fleet-management/bookings/${booking._id}`, { booking });
  };

  if (isLoading) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-center py-5">
              <Spinner animation="border" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body text-danger py-4">
            Failed to load bookings. {error?.response?.data?.message || "Please try again."}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <BookingsHeader
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          total={filteredBookings.length}
        />

        <div className="card-body">
          {filteredBookings.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">No bookings found</p>
            </div>
          ) : (
            <BookingsTable
              bookings={filteredBookings}
              onViewDetails={handleViewDetails}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Bookings;